import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { getWidgetMeta } from 'core-components/sitebuilder/helpers/MetaSelector'
import { prepareStaticParamsTypes } from 'core-components/sitebuilder/layout/flexItem/widgetItem/helpers/prepareStaticParamsTypes'
import { IPageWidget, IStaticProps } from 'core-components/sitebuilder/models/IWidget'

import { DEFAULT_TYPE } from './staticPropsEditor/constants/staticPropsType'
import { TypeSelector } from './staticPropsEditor/TypeSelector'
import { ValueEditor } from './staticPropsEditor/ValueEditor'

import styles from './StaticPropsEditor.module.scss'

interface IStaticPropsEditor {
  viewModel: string
  staticProps: IStaticProps[] | undefined
  onChange: (field: Partial<keyof IPageWidget>, value: any) => void
}

export const StaticPropsEditor = ({
  staticProps = [],
  onChange,
  viewModel,
}: IStaticPropsEditor) => {
  const { staticPropsMapping } = getWidgetMeta(viewModel)

  const changeStaticValue = (
    index: number,
    value: IStaticProps['paramValue'],
    property: keyof IStaticProps
  ) => {
    if (staticProps) {
      staticProps[index] = {
        ...staticProps[index],
        [property]: value,
      }
      onChange('staticProps', staticProps)
    }
  }

  if (!staticPropsMapping?.length) {
    return null
  }

  return (
    <>
      <div className={styles.line}>
        <div className={styles.header}>Static props mapping</div>
      </div>

      {staticPropsMapping?.map((el, index) => {
        let staticElement = staticProps?.find((staticEl) => staticEl.paramName === el.propName)
        if (!staticElement) {
          if (staticProps) {
            staticProps[index] = {
              paramValue: '',
              paramName: el.propName,
              paramType: el.type,
            }

            staticElement = staticProps[index]
          }
        }

        if (staticElement && typeof el.defaultValue !== 'undefined') {
          const value = staticElement.paramValue
          if ((typeof value === 'string' && !value.length) || typeof value === 'undefined') {
            const newValue = prepareStaticParamsTypes({
              ...staticElement,
              paramValue: el.defaultValue,
            }) as IStaticProps['paramValue']
            changeStaticValue(index, newValue, 'paramValue')
          }
        }

        return (
          <div className={styles.line} key={index}>
            <div className={styles.paramName}>
              <Input
                classes={{ root: styles.paramNameWidth }}
                disabled={true}
                label="Static parameter name"
                value={el?.propName || ''}
                onChange={(value) => {
                  changeStaticValue(index, value, 'paramName')
                }}
              />
              <Tooltip
                className={!el.description ? 'content-invisible' : ''}
                tipContent={() => <div>{el.description}</div>}
                horizontalStartPosition={TPopupHorizontal.Center}
                horizontalDirection={TPopupHorizontal.Center}
              >
                <Button variant={'text'} iconButton={'kbase kbase-info'} />
              </Tooltip>
            </div>

            <ValueEditor
              staticElement={staticElement}
              isRequired={el.isRequired}
              dropdownItems={el.dropdownItems}
              dropdownSource={el.dropdownSource}
              onChange={(value) => {
                changeStaticValue(index, value, 'paramValue')
              }}
            />

            <TypeSelector
              className={styles.selectorWidth}
              disabled={true}
              value={staticElement?.paramType || DEFAULT_TYPE}
              onChange={(value) => {
                changeStaticValue(index, value, 'paramType')
              }}
            />
          </div>
        )
      })}
    </>
  )
}
